<template>
  <q-dialog ref="dialog" @hide="onDialogHide" full-width class="payment-page">
    <q-card class="q-dialog-plugin">

      <q-card-section>
        <p class="text-center">
          Zoom image for details
        </p>
        <img :src="src" ref="panzoom">

      </q-card-section>
      <q-card-actions align="right">
        <q-btn color="primary" text-color="dark" label="Close" flat @click="onCancelClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>

</template>

<script>

import Panzoom from 'panzoom'

export default {
  name: "ImageViewerDialog",
  props: {
    src: {
      required: true
    }
  },
  mounted () {
    setTimeout(() => {
      const elem = this.$refs.panzoom
      this.panzoom = Panzoom(elem, {
        maxScale: 5
      })
    }, 100)
  },
  data () {
    return {
      panzoom: null
    }
  },
  methods: {

    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.$refs.dialog.show()
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },

    onOKClick () {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok')
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide()
    },

    onCancelClick () {
      // we just need to hide the dialog
      this.hide()
    }
  },

}
</script>

<style scoped>

</style>
